// cab icons
import CobaltIcon from "../../../../static/images/TSDD/cabinets/cobalt_icon.webp";
import HammerfaustIcon from "../../../../static/images/TSDD/cabinets/hammerfaust_icon.webp";
import IconaIcon from "../../../../static/images/TSDD/cabinets/icona_icon.webp";
import NassauIcon from "../../../../static/images/TSDD/cabinets/naussau_icon.webp";

// Mic icons
import SM57Icon from "../../../../static/images/micIcons/WM57_icon.webp";
import MD421Icon from "../../../../static/images/micIcons/WM421_icon.webp";
import SM7BIcon from "../../../../static/images/micIcons/WM7B_icon.webp";
import E906Icon from "../../../../static/images/micIcons/WM906_icon.webp";
import R121Icon from "../../../../static/images/micIcons/WM121_icon.webp";
import KM184Icon from "../../../../static/images/micIcons/WM184_icon.webp";
import TLM193Icon from "../../../../static/images/micIcons/WM193_icon.webp";

// COBALT AUDIO
import cobaltSM57 from "../../../../static/audio/TSDD/Cabinets/Cobalt/cobalt_cab_sm57.mp3"
import cobaltMD421 from "../../../../static/audio/TSDD/Cabinets/Cobalt/cobalt_cab_md421.mp3"
import cobaltSM7B from "../../../../static/audio/TSDD/Cabinets/Cobalt/cobalt_cab_sm7b.mp3"
import cobaltE906 from "../../../../static/audio/TSDD/Cabinets/Cobalt/cobalt_cab_e906.mp3"
import cobaltR121 from "../../../../static/audio/TSDD/Cabinets/Cobalt/cobalt_cab_r121.mp3"
import cobaltKM184 from "../../../../static/audio/TSDD/Cabinets/Cobalt/cobalt_cab_km184.mp3"
import cobaltTLM193 from "../../../../static/audio/TSDD/Cabinets/Cobalt/cobalt_cab_tlm193.mp3"

// HAMMERFAUST AUDIO
import hammerfaustSM57 from "../../../../static/audio/TSDD/Cabinets/Hammerfaust/hammer_cab_sm57.mp3"
import hammerfaustMD421 from "../../../../static/audio/TSDD/Cabinets/Hammerfaust/hammer_cab_md421.mp3"
import hammerfaustSM7B from "../../../../static/audio/TSDD/Cabinets/Hammerfaust/hammer_cab_sm7b.mp3"
import hammerfaustE906 from "../../../../static/audio/TSDD/Cabinets/Hammerfaust/hammer_cab_e906.mp3"
import hammerfaustR121 from "../../../../static/audio/TSDD/Cabinets/Hammerfaust/hammer_cab_r121.mp3"
import hammerfaustKM184 from "../../../../static/audio/TSDD/Cabinets/Hammerfaust/hammer_cab_km184.mp3"
import hammerfaustTLM193 from "../../../../static/audio/TSDD/Cabinets/Hammerfaust/hammer_cab_tlm193.mp3"

// ICONA AUDIO
import iconaSM57 from "../../../../static/audio/TSDD/Cabinets/Icona/icona_cab_sm57.mp3"
import iconaMD421 from "../../../../static/audio/TSDD/Cabinets/Icona/icona_cab_md421.mp3"
import iconaSM7B from "../../../../static/audio/TSDD/Cabinets/Icona/icona_cab_sm7b.mp3"
import iconaE906 from "../../../../static/audio/TSDD/Cabinets/Icona/icona_cab_e906.mp3"
import iconaR121 from "../../../../static/audio/TSDD/Cabinets/Icona/icona_cab_r121.mp3"
import iconaKM184 from "../../../../static/audio/TSDD/Cabinets/Icona/icona_cab_km184.mp3"
import iconaTLM193 from "../../../../static/audio/TSDD/Cabinets/Icona/icona_cab_tlm193.mp3"

// NASSAU AUDIO
import nassauSM57 from "../../../../static/audio/TSDD/Cabinets/Nassau/nassau_cab_sm57.mp3"
import nassauMD421 from "../../../../static/audio/TSDD/Cabinets/Nassau/nassau_cab_md421.mp3"
import nassauSM7B from "../../../../static/audio/TSDD/Cabinets/Nassau/nassau_cab_sm7b.mp3"
import nassauE906 from "../../../../static/audio/TSDD/Cabinets/Nassau/nassau_cab_e906.mp3"
import nassauR121 from "../../../../static/audio/TSDD/Cabinets/Nassau/nassau_cab_r121.mp3"
import nassauKM184 from "../../../../static/audio/TSDD/Cabinets/Nassau/nassau_cab_km184.mp3"
import nassauTLM193 from "../../../../static/audio/TSDD/Cabinets/Nassau/nassau_cab_tlm193.mp3"

const COBALT = {
  id: "cab-1",
  name: "Cobalt 4x12",
  subtitle: "The Ultimate Allrounder",
  image: CobaltIcon,
  tags: ["Deep Low End", "Midrange Bite"],
  mics: [
    {
      id: "sm57",
      name: "WM-57",
      realMic: "Shure SM57",
      position: 2.2, // 0–10
      distance: 0.5, // 0–10
      description:
        "Close dynamic mic on the cap edge, the golden standard for recording guitars.",
      audio: cobaltSM57,
      icon: SM57Icon,
      amp: "Cobalt",
    },
    {
      id: "md421",
      name: "WM-421",
      realMic: "Sennheiser MD 421",
      position: 1.2,
      distance: 1.2,
      description:
        "Great alternative to the norm. The scooped mids in this microphone blend well together with other microphones",
      audio: cobaltMD421,
      icon: MD421Icon,
      amp: "Cobalt",
    },
    {
      id: "sm7b",
      name: "WM-7B",
      realMic: "Shure SM7B",
      position: 2.4,
      distance: 0.0,
      description:
        "The large diaphragm brother of the standard 57. The larger capsule captures more bass and tames to highs slightly.",
      audio: cobaltSM7B,
      icon: SM7BIcon,
      amp: "Cobalt",
    },
    {
      id: "e906",
      name: "WM-906",
      realMic: "Sennheiser E906",
      position: 1.8,
      distance: 1.5,
      description:
        "Another good allround dynamic microphone. You can place this one virtually everywhere and it will always sound good.",
      audio: cobaltE906,
      icon: E906Icon,
      amp: "Cobalt",
    },
    {
      id: "r121",
      name: "WM-121",
      realMic: "Royer R-121",
      position: 0.0,
      distance: 3.0,
      description:
        "The legendary ribbon microphone for guitars. With smooth highs and a thick bottom, it makes for a great fill mic to blend with the more harsh sounding microphones in the collection. ",
      audio: cobaltR121,
      icon: R121Icon,
      amp: "Cobalt",
    },
    {
      id: "km184",
      name: "WM-184",
      realMic: "Neumann KM 184",
      position: 0.8,
      distance: 2.0,
      description:
        "A high end small diaphgram condenser (SDC) microphone. This one captures the complete spectrum from sub-lows to the highest highs. A great alternative to the standard dynamic microphones.",
      audio: cobaltKM184,
      icon: KM184Icon,
      amp: "Cobalt",
    },
    {
      id: "tlm193",
      name: "WM-193",
      realMic: "Neumann TLM 193",
      position: 0.0,
      distance: 0.0,
      description:
        "A high end large diaphragm condenser (LDC) microphone. This microphone has a darker character and a great focus on the low mids. It lends itself very well for blending together with harsher microphones, or boost the highs and use this one on its own.",
      audio: cobaltTLM193,
      icon: TLM193Icon,
      amp: "Cobalt",
    },

  ],
}

const HAMMERFAUST = {
  id: "cab-2",
  name: "Hammerfaust Oversized 4x12",
  subtitle: "Modern & Tight",
  image: HammerfaustIcon,
  tags: ["Tight Bass", "Smooth Treble"],
  mics: [
    {
      id: "sm57",
      name: "WM-57",
      realMic: "Shure SM57",
      position: 2.2, // 0–10
      distance: 0.5, // 0–10
      description:
        "Close dynamic mic on the cap edge, the golden standard for recording guitars.",
      audio: hammerfaustSM57,
      icon: SM57Icon,
      amp: "Cobalt",
    },
    {
      id: "md421",
      name: "WM-421",
      realMic: "Sennheiser MD 421",
      position: 1.2,
      distance: 1.2,
      description:
        "Great alternative to the norm. The scooped mids in this microphone blend well together with other microphones",
      audio: hammerfaustMD421,
      icon: MD421Icon,
      amp: "Cobalt",
    },
    {
      id: "sm7b",
      name: "WM-7B",
      realMic: "Shure SM7B",
      position: 2.4,
      distance: 0.0,
      description:
        "The large diaphragm brother of the standard 57. The larger capsule captures more bass and tames to highs slightly.",
      audio: hammerfaustSM7B,
      icon: SM7BIcon,
      amp: "Cobalt",
    },
    {
      id: "e906",
      name: "WM-906",
      realMic: "Sennheiser E906",
      position: 1.8,
      distance: 1.5,
      description:
        "Another good allround dynamic microphone. You can place this one virtually everywhere and it will always sound good.",
      audio: hammerfaustE906,
      icon: E906Icon,
      amp: "Cobalt",
    },
    {
      id: "r121",
      name: "WM-121",
      realMic: "Royer R-121",
      position: 0.0,
      distance: 3.0,
      description:
        "The legendary ribbon microphone for guitars. With smooth highs and a thick bottom, it makes for a great fill mic to blend with the more harsh sounding microphones in the collection. ",
      audio: hammerfaustR121,
      icon: R121Icon,
      amp: "Cobalt",
    },
    {
      id: "km184",
      name: "WM-184",
      realMic: "Neumann KM 184",
      position: 0.8,
      distance: 2.0,
      description:
        "A high end small diaphgram condenser (SDC) microphone. This one captures the complete spectrum from sub-lows to the highest highs. A great alternative to the standard dynamic microphones.",
      audio: hammerfaustKM184,
      icon: KM184Icon,
      amp: "Cobalt",
    },
    {
      id: "tlm193",
      name: "WM-193",
      realMic: "Neumann TLM 193",
      position: 0.0,
      distance: 0.0,
      description:
        "A high end large diaphragm condenser (LDC) microphone. This microphone has a darker character and a great focus on the low mids. It lends itself very well for blending together with harsher microphones, or boost the highs and use this one on its own.",
      audio: hammerfaustTLM193,
      icon: TLM193Icon,
      amp: "Cobalt",
    },

  ],
}

const ICONA = {
  id: "cab-3",
  name: "Icona 4x12",
  subtitle: "Old School Scooped Mids",
  image: IconaIcon,
  tags: ["Scooped Mids", "Aggressive Highs"],
  mics: [
    {
      id: "sm57",
      name: "WM-57",
      realMic: "Shure SM57",
      position: 2.2, // 0–10
      distance: 0.5, // 0–10
      description:
        "Close dynamic mic on the cap edge, the golden standard for recording guitars.",
      audio: iconaSM57,
      icon: SM57Icon,
      amp: "Cobalt",
    },
    {
      id: "md421",
      name: "WM-421",
      realMic: "Sennheiser MD 421",
      position: 1.2,
      distance: 1.2,
      description:
        "Great alternative to the norm. The scooped mids in this microphone blend well together with other microphones",
      audio: iconaMD421,
      icon: MD421Icon,
      amp: "Cobalt",
    },
    {
      id: "sm7b",
      name: "WM-7B",
      realMic: "Shure SM7B",
      position: 2.4,
      distance: 0.0,
      description:
        "The large diaphragm brother of the standard 57. The larger capsule captures more bass and tames to highs slightly.",
      audio: iconaSM7B,
      icon: SM7BIcon,
      amp: "Cobalt",
    },
    {
      id: "e906",
      name: "WM-906",
      realMic: "Sennheiser E906",
      position: 1.8,
      distance: 1.5,
      description:
        "Another good allround dynamic microphone. You can place this one virtually everywhere and it will always sound good.",
      audio: iconaE906,
      icon: E906Icon,
      amp: "Cobalt",
    },
    {
      id: "r121",
      name: "WM-121",
      realMic: "Royer R-121",
      position: 0.0,
      distance: 3.0,
      description:
        "The legendary ribbon microphone for guitars. With smooth highs and a thick bottom, it makes for a great fill mic to blend with the more harsh sounding microphones in the collection. ",
      audio: iconaR121,
      icon: R121Icon,
      amp: "Cobalt",
    },
    {
      id: "km184",
      name: "WM-184",
      realMic: "Neumann KM 184",
      position: 0.8,
      distance: 2.0,
      description:
        "A high end small diaphgram condenser (SDC) microphone. This one captures the complete spectrum from sub-lows to the highest highs. A great alternative to the standard dynamic microphones.",
      audio: iconaKM184,
      icon: KM184Icon,
      amp: "Cobalt",
    },
    {
      id: "tlm193",
      name: "WM-193",
      realMic: "Neumann TLM 193",
      position: 0.0,
      distance: 0.0,
      description:
        "A high end large diaphragm condenser (LDC) microphone. This microphone has a darker character and a great focus on the low mids. It lends itself very well for blending together with harsher microphones, or boost the highs and use this one on its own.",
      audio: iconaTLM193,
      icon: TLM193Icon,
      amp: "Cobalt",
    },

  ],
}

const NASSAU = {
  id: "cab-4",
  name: "Nassau Open Back 2x12",
  subtitle: "Vintage Open Back Tones",
  image: NassauIcon,
  tags: ["Open Sound", "Vintage"],
  mics: [
    {
      id: "sm57",
      name: "WM-57",
      realMic: "Shure SM57",
      position: 2.2, // 0–10
      distance: 0.5, // 0–10
      description:
        "Close dynamic mic on the cap edge, the golden standard for recording guitars.",
      audio: nassauSM57,
      icon: SM57Icon,
      amp: "Cobalt",
    },
    {
      id: "md421",
      name: "WM-421",
      realMic: "Sennheiser MD 421",
      position: 1.2,
      distance: 1.2,
      description:
        "Great alternative to the norm. The scooped mids in this microphone blend well together with other microphones",
      audio: nassauMD421,
      icon: MD421Icon,
      amp: "Cobalt",
    },
    {
      id: "sm7b",
      name: "WM-7B",
      realMic: "Shure SM7B",
      position: 2.4,
      distance: 0.0,
      description:
        "The large diaphragm brother of the standard 57. The larger capsule captures more bass and tames to highs slightly.",
      audio: nassauSM7B,
      icon: SM7BIcon,
      amp: "Cobalt",
    },
    {
      id: "e906",
      name: "WM-906",
      realMic: "Sennheiser E906",
      position: 1.8,
      distance: 1.5,
      description:
        "Another good allround dynamic microphone. You can place this one virtually everywhere and it will always sound good.",
      audio: nassauE906,
      icon: E906Icon,
      amp: "Cobalt",
    },
    {
      id: "r121",
      name: "WM-121",
      realMic: "Royer R-121",
      position: 0.0,
      distance: 3.0,
      description:
        "The legendary ribbon microphone for guitars. With smooth highs and a thick bottom, it makes for a great fill mic to blend with the more harsh sounding microphones in the collection. ",
      audio: nassauR121,
      icon: R121Icon,
      amp: "Cobalt",
    },
    {
      id: "km184",
      name: "WM-184",
      realMic: "Neumann KM 184",
      position: 0.8,
      distance: 2.0,
      description:
        "A high end small diaphgram condenser (SDC) microphone. This one captures the complete spectrum from sub-lows to the highest highs. A great alternative to the standard dynamic microphones.",
      audio: nassauKM184,
      icon: KM184Icon,
      amp: "Cobalt",
    },
    {
      id: "tlm193",
      name: "WM-193",
      realMic: "Neumann TLM 193",
      position: 0.0,
      distance: 0.0,
      description:
        "A high end large diaphragm condenser (LDC) microphone. This microphone has a darker character and a great focus on the low mids. It lends itself very well for blending together with harsher microphones, or boost the highs and use this one on its own.",
      audio: nassauTLM193,
      icon: TLM193Icon,
      amp: "Cobalt",
    },
  ],
}




export const CABINETS = [
  COBALT,
  HAMMERFAUST,
  ICONA,
  NASSAU
];